import React from "react";
import { StyledEngineProvider, ThemeProvider } from "@mui/material";
import { DesktopTimePicker, LocalizationProvider, renderTimeViewClock } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import theme from "./theme";
import { SVGAsset } from "res";
import dayjs from "dayjs";
import "./styles.css";

/**
 * @function UITimeClock
 * @typedef {import("@mui/x-date-pickers").DesktopTimePickerProps} MUIDesktopTimePicker
 * @param {MUIDesktopTimePicker} props - pass MUI Select props or other props.
 * @param {dayjs} value = pass a dayjs instance as value
 * @description Time clock component
 * @returns {React.Component}
 * @exported true
*/
export default function UITimeClock(props) {
    const { dateLabel = "", ...rest } = props;

    return (
        <StyledEngineProvider injectFirst>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
                <ThemeProvider theme={theme}>
                    <DesktopTimePicker
                        className="ui-time-clock"
                        label={dateLabel}
                        views={["hours", "minutes"]}
                        closeOnSelect
                        viewRenderers={{
                            hours: (_props) => renderTimeViewClock({ ..._props, className: "ui-time-clock-hours-view", }),
                            minutes: (_props) => renderTimeViewClock({ ..._props, className: "ui-time-clock-minutes-view" }),
                        }}
                        slots={{
                            openPickerIcon: ClockPickerIcon,
                        }}
                        slotProps={{
                            popper: {
                                disablePortal: true,
                                className: "ui-time-clock-popper",
                            },
                            desktopPaper: {
                                className: "ui-time-clock-paper"
                            },
                            desktopTransition: { timeout: 50 },
                            previousIconButton: { sx: { display: "none" } },
                            nextIconButton: { sx: { display: "none" } },
                            actionBar: { actions: [] },
                            inputAdornment: {
                                position: "end",
                                className: "clock-icon-button"
                            },
                            textField: {
                                readOnly: true,
                                variant: "standard",
                            },

                        }}
                        {...rest}
                    />
                </ThemeProvider>
            </LocalizationProvider>
        </StyledEngineProvider>
    );
}

function ClockPickerIcon() {
    return <SVGAsset id="ClockIcon" className="clock-icon" />;
}